<template>
  <transition name="slide-fade">
    <div class="main-account-content" :class="{ center: !viewBirthDay }">
      <transition name="slide-fade">
        <div class="block-invite">
          <h3>Invite your friends 
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path d="M12.1843 27.2523C12.8051 27.1269 13.4332 26.8679 14.0463 26.8995C16.6353 27.033 19.0541 26.5214 21.2967 25.2175C21.4183 25.1467 21.4661 24.9492 21.5484 24.8109C21.504 24.8178 21.4592 24.8246 21.4149 24.8318L21.4238 24.8408C21.5727 24.6134 21.7216 24.386 21.8705 24.1586C21.9354 24.1995 22.0007 24.2405 22.0655 24.2819C21.964 24.4457 21.8624 24.6091 21.5083 25.1796C22.0463 24.752 22.22 24.6142 22.3936 24.4764L22.3736 24.496C22.6569 23.2335 23.1441 22.265 24.4523 21.5759C25.0637 21.2538 25.0803 19.8279 25.3944 18.9114C25.7711 17.811 26.1773 16.7205 26.5711 15.6256C26.6061 15.6453 26.6411 15.6653 26.6761 15.685C26.6343 15.6717 26.5929 15.6585 26.5511 15.6448C26.7887 15.3539 27.0264 15.0624 27.2645 14.7715C27.4415 15.065 27.5951 15.3769 27.8055 15.6444C27.9079 15.7746 28.204 15.9311 28.2607 15.8859C28.4766 15.7135 28.6639 15.4823 28.8009 15.2387C29.1418 14.6341 29.449 14.0103 29.7703 13.3946C29.9115 13.471 30.0523 13.5474 30.1935 13.6237V16.0766L30.2136 16.0574C30.1782 16.0937 30.1423 16.13 30.1069 16.1662C30.1423 16.1867 30.1782 16.2068 30.2136 16.2272L30.1948 16.2042C30.1875 16.2968 30.1799 16.3898 30.1726 16.4824C30.2349 16.3898 30.2972 16.2972 30.3595 16.2042L30.3407 16.2255C30.6099 16.1752 30.8787 16.1248 31.148 16.0749V17.4496C31.2137 17.3507 31.3344 17.1685 31.5798 16.799C31.6352 17.2073 31.7777 17.5115 31.6817 17.6758C31.2478 18.4148 30.7461 19.1141 30.0216 20.1974C30.0216 20.1999 29.9431 20.7098 29.868 21.2009C29.6248 21.2862 29.3931 21.3673 29.1614 21.4484L29.1815 21.4287C28.6076 22.3324 28.0273 23.2323 27.462 24.1415C27.18 24.595 26.9244 25.0648 26.636 25.5631C26.6291 25.5478 26.5575 25.3844 26.566 25.404C25.4874 26.3213 24.3217 27.3099 23.1655 28.3104C23.1377 28.3348 23.2188 28.4845 23.2487 28.5758L23.229 28.5558C22.7367 28.7307 22.2336 28.88 21.7541 29.0853C20.0316 29.823 18.3621 30.5854 16.3576 30.2445C15.0341 30.0192 13.6435 30.1711 12.2838 30.1929C12.0768 30.1963 11.8729 30.4101 11.8678 30.4131C11.1181 30.1959 10.5293 30.0252 9.97379 29.8639C9.74979 29.9488 9.44344 30.1874 9.24419 30.1178C8.64003 29.9079 8.07768 29.5785 7.56056 29.0976C6.85912 28.7397 6.15768 28.3821 5.45624 28.0242C5.41912 28.0946 5.38157 28.165 5.34445 28.2354C4.87171 27.8842 4.39853 27.5326 3.92579 27.1815C3.90531 27.2037 3.8844 27.2263 3.86392 27.2485C3.34168 26.7898 2.81901 26.3316 1.93496 25.5555C1.57613 25.0358 0.977519 24.1679 0.288452 23.1695C1.27192 23.0176 2.17389 22.8786 3.07629 22.7399C3.05667 22.7749 3.03704 22.8094 3.01784 22.8444C3.03107 22.803 3.04387 22.7612 3.05709 22.7198C3.47011 22.9925 3.88355 23.2651 4.29656 23.5386C4.09987 23.3854 3.90317 23.2314 3.70605 23.0778C3.66595 23.17 3.62584 23.2626 3.58573 23.3547C3.82253 23.414 4.05933 23.4733 4.29656 23.5326C4.74328 23.941 5.12771 24.4756 5.64909 24.7337C7.08013 25.4415 8.56024 26.0534 10.0403 26.6563C10.3898 26.7988 10.8139 26.7587 11.2043 26.8026C11.1847 26.8372 11.165 26.8713 11.1454 26.9059C11.1586 26.8649 11.1714 26.8235 11.1847 26.7826C11.5251 26.9323 11.8656 27.0825 12.2065 27.2318C12.2415 27.2519 12.2765 27.2724 12.3111 27.2928C12.2697 27.2792 12.2279 27.2651 12.1865 27.2515L12.1843 27.2523ZM21.7762 27.7989C21.8035 27.7677 21.8304 27.7366 21.8577 27.7054C21.8373 27.743 21.8163 27.781 21.7959 27.8194C21.7762 27.8535 21.757 27.888 21.7374 27.9222C21.7502 27.8808 21.763 27.8398 21.7762 27.7984V27.7989ZM27.6809 18.2074C27.6642 18.288 27.6476 18.3687 27.6762 18.23C27.7116 18.3627 27.6894 18.2799 27.6711 18.2002C27.7402 18.1609 27.8089 18.1221 27.878 18.0828C28.1024 17.73 28.3269 17.3767 28.5018 17.1011C28.393 16.7542 28.3021 16.4632 28.0777 15.7468C27.9962 16.8071 27.9467 17.4548 27.8968 18.1029C27.8251 18.1379 27.753 18.1728 27.6813 18.2074H27.6809ZM23.5192 27.2792C22.7465 27.3522 22.4709 27.3786 22.1957 27.4046C22.2123 27.5416 22.2289 27.6781 22.2456 27.8151C22.5357 27.6931 22.8263 27.571 23.5192 27.2792ZM29.9431 20.6232C29.6128 20.7392 29.4929 20.7619 29.4929 20.7849C29.4925 20.8894 29.5258 20.9944 29.5471 21.0989C29.6248 21.0059 29.7024 20.9125 29.9431 20.6232ZM20.9088 28.1406C20.9494 28.144 20.9895 28.147 21.03 28.1504C21.0667 28.0536 21.1038 27.9567 21.1405 27.8599C21.097 27.8454 21.0539 27.8309 21.0104 27.8164C20.9767 27.9243 20.9425 28.0327 20.9088 28.1406ZM19.2269 28.4914C19.2751 28.5071 19.3161 28.5212 19.3575 28.5349C19.3647 28.502 19.3745 28.4696 19.3758 28.4367C19.3758 28.4316 19.3314 28.4141 19.3165 28.4214C19.2849 28.4367 19.2598 28.4645 19.2269 28.4914ZM22.7059 23.964C22.6957 24.0143 22.6872 24.0557 22.6791 24.0971C22.7119 24.0988 22.7456 24.1044 22.7772 24.0992C22.784 24.098 22.7943 24.0506 22.7853 24.0365C22.7674 24.0092 22.7367 23.9909 22.7059 23.964ZM29.9887 16.6757C29.9717 16.6906 29.955 16.7055 29.9379 16.7205C29.9529 16.7375 29.9678 16.7542 29.9827 16.7712C29.9994 16.7563 30.0288 16.7422 30.0297 16.726C30.031 16.7102 30.0032 16.6927 29.9883 16.6757H29.9887ZM22.7768 25.5772C22.7618 25.5606 22.7473 25.5439 22.7324 25.5269C22.7158 25.5418 22.6867 25.5555 22.6859 25.5717C22.685 25.5875 22.7111 25.6173 22.7269 25.6182C22.7426 25.619 22.7601 25.5922 22.7768 25.5772ZM6.76952 26.8342C6.75331 26.8487 6.73667 26.8628 6.72045 26.8773C6.73496 26.8935 6.74904 26.9101 6.76355 26.9263C6.77976 26.9118 6.80835 26.8986 6.8092 26.8828C6.81048 26.8675 6.78403 26.8504 6.76952 26.8342ZM12.038 27.4635C12.0231 27.4464 12.0081 27.4298 11.9932 27.4127C11.9761 27.4277 11.9471 27.4418 11.9463 27.458C11.945 27.4738 11.9719 27.5036 11.9877 27.5049C12.0034 27.5058 12.0214 27.4784 12.038 27.4635ZM12.038 28.3343C12.0231 28.3173 12.0081 28.3006 11.9932 28.2836C11.9761 28.2985 11.9595 28.3134 11.9424 28.3284C11.9574 28.3454 11.9714 28.3744 11.9877 28.3753C12.0034 28.3762 12.0209 28.3488 12.038 28.3339V28.3343ZM8.35971 29.5397C8.37677 29.5247 8.39341 29.5098 8.41048 29.4949C8.39555 29.4778 8.38147 29.4488 8.36525 29.4479C8.34947 29.4471 8.31917 29.4735 8.31832 29.4893C8.31747 29.5051 8.34477 29.523 8.35971 29.5397ZM9.23053 29.9749C9.2476 29.9599 9.26424 29.945 9.28131 29.9301C9.26637 29.913 9.25229 29.884 9.23608 29.8831C9.22029 29.8819 9.19 29.9087 9.18915 29.9245C9.18829 29.9407 9.2156 29.9582 9.23053 29.9749ZM10.9265 7.35471C10.9666 8.30021 11.0968 9.25295 11.0255 10.1899C10.9291 11.4597 10.6138 12.7128 10.5093 13.9826C10.3689 15.6837 9.20109 14.7804 8.42541 14.882L8.44504 14.902C8.00813 13.9975 7.55075 13.1019 7.14712 12.1824C7.02211 11.8979 7.00547 11.5488 7.00547 11.2293C7.00419 9.89594 7.03789 8.56261 7.03661 7.22927C7.03661 6.7817 6.84845 6.30085 6.95853 5.89253C7.21325 4.94703 7.56781 4.02415 7.93816 3.11493C8.24963 2.34991 8.28419 2.36655 9.37133 2.63663C9.40035 2.64389 9.47843 2.45487 9.53347 2.35759L9.52963 2.35887C9.71395 2.47493 9.89869 2.59098 10.083 2.70703C10.0194 2.76293 9.95587 2.81925 9.89187 2.87514C9.85645 2.85551 9.82189 2.83589 9.78691 2.81583C9.82872 2.82906 9.87011 2.84229 9.91192 2.85551C10.2524 3.71311 10.6812 4.54895 10.9022 5.43642C11.0537 6.04485 10.9159 6.72538 10.9073 7.37349C10.8723 7.35386 10.8374 7.33381 10.8028 7.31375C10.8442 7.32698 10.886 7.34063 10.9274 7.35386L10.9265 7.35471ZM7.39373 10.3418C7.37923 10.3252 7.36429 10.3085 7.34979 10.2919C7.33315 10.3064 7.30456 10.3205 7.30328 10.3363C7.302 10.3516 7.32845 10.3815 7.34381 10.3823C7.3596 10.3832 7.37667 10.3567 7.39331 10.3418H7.39373ZM18.1688 15.1934C17.7609 14.4788 17.1456 13.8042 16.9997 13.0396C16.8307 12.1564 17.1017 11.1951 17.1298 10.2663C17.1443 9.79013 17.0104 9.31141 17.0044 8.83311C16.9903 7.74255 16.716 6.53253 17.0919 5.58831C17.6423 4.20677 18.6398 2.99333 19.5217 1.76154C19.6877 1.52943 20.2023 1.54693 20.556 1.44922C20.7471 2.26117 21.1435 3.08719 21.0902 3.88293C20.9327 6.24666 20.6921 8.61509 20.2923 10.9485C20.1016 12.063 19.5038 13.1151 19.0349 14.1707C18.8647 14.5543 18.5336 14.8662 18.2759 15.2109L18.2959 15.1913C18.2473 15.1853 18.1986 15.1794 18.1496 15.173L18.1692 15.193L18.1688 15.1934ZM20.0743 4.13082L20.2257 4.14362C20.2044 3.79375 20.1835 3.44389 20.1622 3.09402C20.1007 3.09786 20.0397 3.10127 19.9783 3.10511C20.0103 3.44687 20.0423 3.78906 20.0747 4.13082H20.0743ZM17.117 9.47183C17.1025 9.45519 17.0885 9.42618 17.0731 9.42533C17.0573 9.42447 17.0402 9.45135 17.0236 9.46586C17.0381 9.4825 17.0522 9.51109 17.068 9.51237C17.0833 9.51322 17.1008 9.48677 17.1175 9.47183H17.117ZM20.4557 4.68335C20.4408 4.66629 20.4258 4.64965 20.4109 4.63258C20.3938 4.64751 20.3772 4.66245 20.3601 4.67738C20.3751 4.69445 20.3891 4.72346 20.4054 4.72431C20.4211 4.72559 20.4386 4.69786 20.4557 4.68293V4.68335ZM20.4113 1.58575C20.3943 1.60069 20.3653 1.61477 20.3644 1.63055C20.3635 1.64634 20.3909 1.66426 20.4058 1.6809C20.4229 1.66597 20.4519 1.65189 20.4527 1.63567C20.454 1.61989 20.4263 1.60239 20.4113 1.58533V1.58575ZM21.4234 24.8399C21.2267 24.8719 21.0309 24.9052 20.835 24.9385C20.873 25.0179 20.9105 25.0972 20.9485 25.1762C21.1042 25.0614 21.2595 24.9466 21.4153 24.8318C21.4153 24.8318 21.4242 24.8408 21.423 24.8399H21.4234ZM10.2554 15.554C10.2417 15.4277 10.2362 15.2988 10.2046 15.1772C10.2003 15.1602 10.0668 15.1764 9.99341 15.1772C10.0118 15.3146 10.0301 15.4524 10.0489 15.5898C10.118 15.5779 10.1867 15.5659 10.2558 15.554H10.2554ZM4.13699 28.1718C4.00173 28.1061 3.86691 28.0404 3.73208 27.9747C3.71373 28.016 3.69496 28.057 3.67661 28.0984C3.81485 28.1573 3.95352 28.2166 4.09176 28.2755C4.10669 28.2409 4.12205 28.2063 4.13699 28.1722V28.1718ZM4.38488 28.6223C4.47533 28.598 4.5564 28.5383 4.64088 28.4922C4.52184 28.4675 4.4028 28.4423 4.22616 28.4056C4.30893 28.5221 4.36227 28.6287 4.38488 28.6228V28.6223ZM10.4086 26.6213C10.4282 26.5782 10.4478 26.5351 10.4674 26.492C10.3552 26.4523 10.243 26.4126 9.6316 26.1959C10.2042 26.5095 10.3066 26.5654 10.409 26.6213H10.4086ZM20.809 29.8772C20.7851 29.8614 20.7296 29.8925 20.6887 29.9023C20.733 29.9651 20.777 30.0282 20.8214 30.0909C20.8482 30.0692 20.8747 30.047 20.9174 30.012C20.8819 29.9651 20.8546 29.9075 20.809 29.8767V29.8772ZM8.64899 30.1882H8.36141C8.36141 30.2083 8.36141 30.2279 8.36141 30.2479H8.64899C8.64899 30.2279 8.64899 30.2083 8.64899 30.1882ZM24.9878 27.6717C24.9989 27.5971 25.0099 27.5224 24.995 27.6218C25.062 27.5471 25.0151 27.5996 24.9681 27.6517L24.9878 27.6717ZM3.42957 27.3206C3.41677 27.4046 3.40397 27.4887 3.42957 27.3223C3.47011 27.4878 3.45005 27.4055 3.42957 27.3236V27.3206ZM3.42915 27.324C3.34168 27.3052 3.25421 27.2856 3.41976 27.3223C3.25336 27.3534 3.34168 27.3368 3.43 27.3206C3.43 27.3206 3.43 27.3236 3.42957 27.324H3.42915ZM9.55864 26.2432C9.55181 26.2752 9.542 26.3072 9.54072 26.3392C9.54072 26.3444 9.58424 26.3614 9.59875 26.3546C9.62947 26.3397 9.65464 26.3124 9.68664 26.2859C9.63928 26.2701 9.59917 26.2569 9.55864 26.2432ZM9.53219 2.35887C9.51256 2.27098 9.49251 2.18309 9.53048 2.35077C9.56163 2.18095 9.54499 2.27055 9.52877 2.36015L9.53261 2.35887H9.53219ZM29.1606 21.4496C29.2007 21.4616 29.2403 21.4731 29.2805 21.4851C29.2476 21.4667 29.2143 21.4484 29.181 21.43C29.1806 21.43 29.1606 21.4496 29.1606 21.4496ZM30.2131 16.0587C30.2131 16.1155 30.2131 16.1718 30.2131 16.2285L30.1944 16.2055C30.249 16.2055 30.304 16.2055 30.3586 16.2055C30.3586 16.2055 30.3399 16.2268 30.3399 16.2264C30.2908 16.1765 30.2417 16.127 30.1927 16.0771L30.2127 16.0579L30.2131 16.0587ZM5.31715 24.0771C5.30051 24.0916 5.27235 24.1052 5.27107 24.121C5.26979 24.1364 5.29581 24.1658 5.31117 24.1667C5.32696 24.1675 5.34403 24.1411 5.36024 24.1266C5.34573 24.1099 5.33123 24.0937 5.31672 24.0771H5.31715ZM22.3928 24.476C22.3527 24.4645 22.3126 24.4525 22.2725 24.441C22.3057 24.4594 22.3386 24.4777 22.3723 24.496C22.3727 24.496 22.3928 24.4764 22.3928 24.4764V24.476ZM7.99235 25.6378C7.95565 25.6169 7.91896 25.596 7.88227 25.5751C7.91213 25.6024 7.94243 25.6301 7.97229 25.6574L7.99235 25.6378ZM19.7803 25.5717C19.7948 25.5883 19.8093 25.605 19.8238 25.6212C19.8405 25.6067 19.8686 25.593 19.8699 25.5772C19.8712 25.5619 19.8443 25.5444 19.8298 25.5282C19.8131 25.5427 19.7969 25.5572 19.7803 25.5717ZM7.97272 25.6574C8.01283 25.6694 8.05336 25.6809 8.09347 25.6928C8.06019 25.6745 8.02691 25.6562 7.9932 25.6378C7.99277 25.6378 7.97272 25.6574 7.97272 25.6574ZM19.6847 25.8187C19.6681 25.8332 19.6519 25.8477 19.6352 25.8618C19.6497 25.878 19.6634 25.9066 19.6787 25.9075C19.6941 25.9087 19.7112 25.8819 19.7278 25.8678C19.7133 25.8511 19.6988 25.8349 19.6847 25.8187ZM30.7141 15.3714C30.6974 15.3859 30.6808 15.4004 30.6646 15.4149C30.6791 15.4315 30.6927 15.4597 30.7085 15.461C30.7239 15.4622 30.7414 15.4354 30.7576 15.4208C30.7431 15.4042 30.7286 15.388 30.7141 15.3714ZM18.275 15.2114C18.3151 15.222 18.3548 15.2331 18.3949 15.2438C18.3621 15.2263 18.3292 15.2088 18.2955 15.1917C18.2951 15.1917 18.275 15.2118 18.275 15.2118V15.2114ZM24.9686 27.6517C24.957 27.6918 24.9451 27.7319 24.9336 27.772C24.9519 27.7387 24.9703 27.7059 24.9882 27.6722C24.9882 27.6717 24.9686 27.6517 24.9686 27.6517ZM18.1487 15.1734C18.1368 15.2131 18.1248 15.2523 18.1129 15.292C18.1312 15.2596 18.15 15.2267 18.1683 15.1939C18.1683 15.1934 18.1487 15.1734 18.1487 15.1734ZM8.42456 14.8824C8.41304 14.9225 8.40152 14.9622 8.39 15.0023C8.40835 14.9694 8.42627 14.9362 8.44419 14.9029C8.44419 14.9024 8.42456 14.8824 8.42456 14.8824ZM23.2478 28.5758C23.2593 28.5357 23.2709 28.4956 23.2824 28.4555C23.264 28.4888 23.2457 28.5221 23.2278 28.5558C23.2278 28.5562 23.2474 28.5763 23.2474 28.5763L23.2478 28.5758ZM4.94552 28.8297C4.90883 28.8088 4.87213 28.7879 4.83501 28.767C4.86531 28.7943 4.89517 28.8216 4.92547 28.8489L4.94552 28.8293V28.8297ZM4.92547 28.8493C4.96557 28.8613 5.00568 28.8732 5.04579 28.8847C5.01251 28.8664 4.97923 28.8476 4.94552 28.8293C4.94509 28.8293 4.92504 28.8489 4.92504 28.8489L4.92547 28.8493ZM7.30029 14.1088C7.3148 14.1255 7.32931 14.1417 7.34381 14.1583C7.36045 14.1438 7.38861 14.1302 7.38989 14.1148C7.39117 14.0995 7.36429 14.082 7.34979 14.0658C7.33315 14.0803 7.31693 14.0948 7.30029 14.1093V14.1088ZM16.637 13.1945C16.6204 13.209 16.5918 13.2227 16.591 13.2384C16.5901 13.2538 16.6157 13.2832 16.6311 13.2841C16.6469 13.285 16.6639 13.2585 16.6806 13.244C16.6661 13.2274 16.6515 13.2107 16.637 13.1945ZM10.9773 12.3245L10.9278 12.368C10.9423 12.3847 10.956 12.4128 10.9718 12.4141C10.9871 12.4154 11.0046 12.3885 11.0208 12.374C11.0063 12.3574 10.9918 12.3412 10.9773 12.3245ZM12.4284 30.4621C12.4118 30.4766 12.3955 30.4911 12.3789 30.5056C12.3934 30.5223 12.4071 30.5504 12.4229 30.5517C12.4382 30.553 12.4557 30.5261 12.4719 30.5116C12.4574 30.495 12.4429 30.4788 12.4284 30.4621ZM9.18957 2.06575C9.18872 2.08154 9.21517 2.09861 9.22968 2.11525C9.24632 2.10074 9.27491 2.08709 9.27576 2.0713C9.27704 2.05594 9.25016 2.03845 9.23565 2.02223C9.21901 2.03674 9.19043 2.05039 9.18957 2.06575Z" fill="#685BC7"/>
              </svg>
          </h3>         
          <p class="text-1" v-html="userDetails.invitedFriends_1"></p>
          <p class="text-2" v-html="userDetails.invitedFriends_2"></p>
          <ul class="social">
              <li class="twitter">
              <a :href="twitter" target="_blank" class="a2a_button_twitter">
                  <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.5156 5.125C22.4531 4.42188 23.2969 3.57812 23.9531 2.59375C23.1094 2.96875 22.125 3.25 21.1406 3.34375C22.1719 2.73438 22.9219 1.79688 23.2969 0.625C22.3594 1.1875 21.2812 1.60938 20.2031 1.84375C19.2656 0.859375 18 0.296875 16.5938 0.296875C13.875 0.296875 11.6719 2.5 11.6719 5.21875C11.6719 5.59375 11.7188 5.96875 11.8125 6.34375C7.73438 6.10938 4.07812 4.14062 1.64062 1.1875C1.21875 1.89062 0.984375 2.73438 0.984375 3.67188C0.984375 5.35938 1.82812 6.85938 3.1875 7.75C2.39062 7.70312 1.59375 7.51562 0.9375 7.14062V7.1875C0.9375 9.57812 2.625 11.5469 4.875 12.0156C4.5 12.1094 4.03125 12.2031 3.60938 12.2031C3.28125 12.2031 3 12.1562 2.67188 12.1094C3.28125 14.0781 5.10938 15.4844 7.26562 15.5312C5.57812 16.8438 3.46875 17.6406 1.17188 17.6406C0.75 17.6406 0.375 17.5938 0 17.5469C2.15625 18.9531 4.73438 19.75 7.54688 19.75C16.5938 19.75 21.5156 12.2969 21.5156 5.78125C21.5156 5.54688 21.5156 5.35938 21.5156 5.125Z" fill="white"/>
                  </svg>
              </a>
              </li>
              <li class="whatsapp">
              <a target="_blank" :href="whatsapp" class="a2a_button_whatsapp">
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.3125 3.59375C16.3906 1.625 13.7656 0.5 10.9531 0.5C5.23438 0.5 0.546875 5.1875 0.546875 10.9062C0.546875 12.7812 1.0625 14.5625 1.95312 16.1094L0.5 21.5L5.98438 20.0938C7.53125 20.8906 9.21875 21.3594 10.9531 21.3594C16.7188 21.3594 21.5 16.6719 21.5 10.9531C21.5 8.14062 20.2812 5.5625 18.3125 3.59375ZM10.9531 19.5781C9.40625 19.5781 7.90625 19.1562 6.54688 18.3594L6.26562 18.1719L2.98438 19.0625L3.875 15.875L3.64062 15.5469C2.79688 14.1406 2.32812 12.5469 2.32812 10.9062C2.32812 6.17188 6.21875 2.28125 11 2.28125C13.2969 2.28125 15.4531 3.17188 17.0938 4.8125C18.7344 6.45312 19.7188 8.60938 19.7188 10.9531C19.7188 15.6875 15.7344 19.5781 10.9531 19.5781ZM15.7344 13.1094C15.4531 12.9688 14.1875 12.3594 13.9531 12.2656C13.7188 12.1719 13.5312 12.125 13.3438 12.4062C13.2031 12.6406 12.6875 13.25 12.5469 13.4375C12.3594 13.5781 12.2188 13.625 11.9844 13.4844C10.4375 12.7344 9.45312 12.125 8.42188 10.3906C8.14062 9.92188 8.70312 9.96875 9.17188 8.98438C9.26562 8.79688 9.21875 8.65625 9.17188 8.51562C9.125 8.375 8.5625 7.10938 8.375 6.59375C8.14062 6.07812 7.95312 6.125 7.76562 6.125C7.625 6.125 7.4375 6.125 7.29688 6.125C7.10938 6.125 6.82812 6.17188 6.59375 6.45312C6.35938 6.73438 5.70312 7.34375 5.70312 8.60938C5.70312 9.92188 6.59375 11.1406 6.73438 11.3281C6.875 11.4688 8.5625 14.0938 11.1875 15.2188C12.8281 15.9688 13.4844 16.0156 14.3281 15.875C14.7969 15.8281 15.8281 15.2656 16.0625 14.6562C16.2969 14.0469 16.2969 13.5312 16.2031 13.4375C16.1562 13.2969 15.9688 13.25 15.7344 13.1094Z" fill="white"/>
                  </svg>
              </a>
              </li>
              <li class="facebook-messenger">
              <a class="a2a_button_facebook_messenger" target="_blank" :href="facebookMessendger"><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0.375C5.4375 0.375 0.375 5.20312 0.375 11.6719C0.375 15.0469 1.73438 18 4.03125 20.0156C4.40625 20.3906 4.3125 20.5781 4.40625 22.7344C4.40625 23.25 4.82812 23.625 5.34375 23.625C5.4375 23.625 5.57812 23.625 5.71875 23.5781C8.15625 22.5 8.20312 22.4062 8.625 22.5C15.7969 24.4688 23.625 19.875 23.625 11.6719C23.625 5.20312 18.5625 0.375 12 0.375ZM18.9844 9.09375L15.5625 14.4844C15.2812 15 14.7188 15.3281 14.1094 15.3281C13.6875 15.3281 13.3594 15.1875 13.0312 14.9531L10.3125 12.9375C10.2188 12.8438 10.0781 12.7969 9.89062 12.7969C9.75 12.7969 9.60938 12.8438 9.46875 12.9375L5.8125 15.7031C5.29688 16.0781 4.6875 15.4688 5.01562 14.9531L8.4375 9.5625C8.71875 9.04688 9.28125 8.71875 9.89062 8.71875C10.3125 8.71875 10.6875 8.85938 10.9688 9.09375L13.6875 11.1094C13.7812 11.2031 13.9219 11.25 14.1094 11.25C14.25 11.25 14.3906 11.2031 14.5312 11.1094L18.1875 8.34375C18.7031 7.96875 19.3125 8.57812 18.9844 9.09375Z" fill="white"/>
                  </svg>
              </a>
              </li>
              <li class="facebook">
              <a target="_blank" :href="facebook"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.625 12C23.625 5.57812 18.4219 0.375 12 0.375C5.57812 0.375 0.375 5.57812 0.375 12C0.375 17.8125 4.59375 22.6406 10.1719 23.4844V15.375H7.21875V12H10.1719V9.46875C10.1719 6.5625 11.9062 4.92188 14.5312 4.92188C15.8438 4.92188 17.1562 5.15625 17.1562 5.15625V8.01562H15.7031C14.25 8.01562 13.7812 8.90625 13.7812 9.84375V12H17.0156L16.5 15.375H13.7812V23.4844C19.3594 22.6406 23.625 17.8125 23.625 12Z" fill="white"/>
                  </svg>
              </a>
              </li>
              <li class="mail">
              <a :href="'https://www.addtoany.com/add_to/email?linkurl=https%3A%2F%2Fcleancutmeals.sitepreview.app%2Flogin%2F?friend=' + friendsCode + '&amp;linkname=Clean%20Cut%20Meals'" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M23.4266 20.0334C22.115 20.0334 20.8154 20.079 19.4978 20.0874C17.999 20.0958 16.5002 20.1414 15.0038 20.2218C14.5406 20.247 8.47455 20.3958 6.14415 20.3022C4.29375 20.2278 2.47815 19.9806 0.646954 19.7442C0.568954 19.7346 0.496954 19.6458 0.430954 19.5834C0.358954 19.5162 0.273754 19.4478 0.235354 19.3614C0.186154 19.2534 0.171754 19.1286 0.153754 19.0086C0.139354 18.9114 0.140554 18.8118 0.139354 18.7122C0.129754 16.6158 -0.0298457 14.5314 0.00495429 12.429C0.0109543 12.0498 0.0181543 11.6694 0.0241543 11.2902C0.0613543 9.06416 -0.135446 6.72776 0.355354 4.54736C0.453754 4.10936 0.668554 4.31576 1.16055 4.30496C1.51215 4.29656 2.64015 4.11776 3.12375 4.05176C5.05935 3.78656 7.03335 3.76136 8.98695 3.80696C10.7246 3.84776 12.4622 3.94976 14.1986 3.87896C14.5826 3.86336 16.607 3.73616 17.2358 3.69776C18.3038 3.69776 22.169 3.55136 22.4822 3.61616C22.6262 3.64616 22.8062 3.62216 22.9118 3.70136C23.171 3.89456 23.531 4.02656 23.267 4.52336C23.0546 4.92296 23.2034 5.45096 23.2166 5.87576C23.2346 6.46856 23.1962 7.06616 23.207 7.66016C23.2274 8.85056 23.2958 10.0386 23.3666 11.2266C23.4362 12.3882 23.5094 13.5498 23.5814 14.7102C23.621 15.3426 23.8226 18.4182 23.8502 18.5118C23.9198 18.7554 24.035 19.023 23.9906 19.2534C23.9438 19.4934 23.7446 19.7106 23.5862 19.9182C23.5094 20.0178 23.3714 20.0706 23.4278 20.0334H23.4266ZM13.8998 12.4938C14.2346 12.2442 14.5454 11.9586 14.8406 11.6622C15.755 10.743 16.5398 9.70856 17.3258 8.68136C18.089 7.68296 18.9422 6.76496 19.6622 5.74616C19.7798 5.57936 19.8938 5.41136 20.0102 5.24336C19.9394 5.24816 19.8674 5.26616 19.8002 5.25416C19.2938 5.16056 11.555 5.52536 9.80415 5.49776C8.91735 5.48336 8.03175 5.46296 7.14615 5.43656C6.32775 5.41136 5.52255 5.44136 4.70895 5.44136C3.95895 5.49776 3.21015 5.55056 2.46015 5.59496C2.53695 5.67656 2.60655 5.76776 2.69295 5.83736C3.18855 6.23936 3.72615 6.57656 4.17855 7.03016C4.65975 7.51376 5.07495 8.05616 5.53575 8.55896C6.19695 9.27776 6.95055 9.91016 7.57335 10.6638C8.08455 11.2818 8.62935 11.8266 9.21616 12.3858C9.32535 12.4902 9.43575 12.5946 9.56295 12.6762C9.70935 12.7686 9.87375 12.8262 10.0334 12.8922C10.3358 13.0146 10.6298 13.1646 10.9442 13.2522C11.6534 13.449 12.4262 13.3122 13.0898 12.9942C13.3766 12.8562 13.6454 12.687 13.8998 12.4974V12.4938ZM20.027 18.2658C20.033 18.2562 20.1038 18.1686 20.1278 18.069C20.1398 18.0162 20.0774 17.9382 20.0354 17.8806C19.8146 17.577 18.7166 15.7422 18.5978 15.5706C18.4214 15.3162 16.6118 12.6642 16.589 12.639C16.493 12.5358 16.3478 12.3294 16.307 12.3486C16.127 12.4314 15.9626 12.5646 15.8222 12.7086C15.7142 12.819 13.6154 14.4162 13.2866 14.5302C12.863 14.6766 12.3962 14.7138 11.9438 14.757C11.6078 14.7894 11.2562 14.8038 10.9274 14.7426C10.5638 14.6754 10.2158 14.5158 9.86296 14.3898C9.68295 14.325 9.50055 14.259 9.33255 14.1702C9.03735 14.0142 8.73855 13.8582 8.46375 13.671C8.18175 13.479 7.92735 13.2486 7.65975 13.0338C7.61055 12.9942 7.56135 12.957 7.51095 12.9174C6.51135 14.757 5.47815 16.5798 4.45215 18.405C4.48695 18.345 5.01495 18.4374 5.07855 18.4434C5.39535 18.4722 5.69895 18.5382 6.01575 18.5394C6.84855 18.5418 7.68255 18.543 8.51535 18.5394C10.1822 18.5322 11.8478 18.513 13.5134 18.4794C14.663 18.4566 15.8126 18.4278 16.961 18.3918C17.9726 18.3606 19.0214 18.3978 20.0258 18.2646L20.027 18.2658ZM6.64575 12.1134C6.56775 11.961 6.52095 11.8062 6.42375 11.6934C6.17655 11.4078 5.92815 11.145 5.67855 10.8534C5.36895 10.491 5.05695 10.1298 4.74255 9.76976C4.10055 9.03416 3.45135 8.30456 2.79495 7.58336C2.38455 7.13216 2.05575 6.73016 1.73535 6.21416C1.71975 6.28376 1.69815 6.35096 1.69095 6.42176C1.56975 7.52576 1.85055 8.58656 1.92135 9.68216C1.96575 10.371 2.00415 13.0086 1.99455 13.2474C1.92615 14.8782 1.98975 16.5798 1.78095 18.1878C1.92735 18.195 2.07735 18.2238 2.22015 18.2034C2.42895 18.1734 2.89815 17.7378 2.96655 17.595C3.05175 17.4186 3.39015 16.7802 3.43695 16.7106C3.70095 16.3182 6.16095 12.6558 6.37455 12.4542C6.47535 12.3594 6.54975 12.237 6.64695 12.1146L6.64575 12.1134ZM21.8486 5.51336C21.647 5.75816 21.5126 5.92496 21.3734 6.08816C21.0518 6.46136 17.915 10.449 17.4602 10.9506C16.973 11.487 16.9574 11.4618 17.2334 11.7222C17.4062 11.8854 17.5526 12.0762 17.723 12.2418C17.9378 12.4518 19.6394 14.4798 19.8026 14.7438C20.0114 15.0834 21.1058 16.8234 21.305 17.1342C21.4622 17.379 21.6338 17.6142 21.8066 17.847C21.863 17.9226 21.9374 17.9862 22.0142 18.0426C22.0394 18.0618 22.1306 18.0426 22.1306 18.0378C22.1354 17.6874 22.1534 17.3358 22.1306 16.9878C22.1078 16.6482 21.7946 12.6498 21.7886 12.2298C21.785 11.9406 21.6866 10.569 21.6518 10.1694C21.629 9.91976 21.7466 7.53896 21.767 7.18136C21.7814 6.93056 21.827 6.68096 21.8318 6.43016C21.8366 6.19616 21.803 5.96216 21.7934 5.72816C21.791 5.67896 21.8186 5.62976 21.8522 5.51216L21.8486 5.51336Z" fill="white"/>
                  </svg>
              </a>   
        
              </li>  
              <a class="a2a_button_facebook"></a>
          </ul>
          <p class="text-3">Or copy your link and share it anywhere</p>
          <div class="invite-form">
              <v-text-field
              label=""
              type="input"
              v-model="friendsCode"
              ></v-text-field>
              <v-btn type="submit" block class="btn btn-copy" @click="copyToClipboard">{{ textBtnCopy }} <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.77975 21.0339C2.76572 21.6988 2.75701 22.1835 2.756 22.4175C2.75167 23.5703 3.7119 24.246 4.79959 23.7785C4.90528 23.7329 5.01183 23.6823 5.11901 23.6315C5.47518 23.4626 5.83826 23.2904 6.19943 23.2829C7.36278 23.2581 8.52678 23.2603 9.69075 23.2625C11.1269 23.2652 12.5631 23.2679 13.9979 23.22C16.8548 23.1235 19.7107 22.9402 22.56 22.707C23.6661 22.617 24.2072 21.5976 24.1057 20.4957C23.9566 18.8787 23.8508 17.2498 23.8692 15.6274C23.9124 11.9682 24.0182 8.308 24.1521 4.64995C24.191 3.59255 23.638 3.15658 22.7566 3.02752C22.2958 2.96011 21.8341 2.89862 21.3719 2.84024C21.2471 6.2843 21.1488 9.73031 21.1083 13.1753C21.0908 14.7282 21.1917 16.2873 21.3338 17.8349C21.4306 18.8895 20.9147 19.8652 19.8603 19.9514C17.1438 20.1746 14.4212 20.35 11.6975 20.4424C10.3296 20.4882 8.96044 20.4857 7.59123 20.4831C6.48156 20.481 5.37186 20.4789 4.26278 20.5026C3.91846 20.5098 3.57231 20.6746 3.23276 20.8362C3.13058 20.8849 3.02899 20.9332 2.92823 20.9769C2.87843 20.9984 2.8289 21.0174 2.77975 21.0339ZM3.08646 6.85889C3.1047 5.54817 3.10624 4.67121 3.08003 4.55668C3.03975 4.37978 3.01252 4.21529 2.99834 4.06283C3.09271 3.13843 4.2538 2.45697 5.15659 2.64167C5.43542 2.6987 8.38533 2.8389 11.4354 2.98386C14.6032 3.13442 17.879 3.2901 18.3826 3.36308C18.3826 4.25187 18.3785 5.11576 18.3746 5.96233C18.3656 7.88215 18.357 9.71284 18.397 11.5425C18.4361 13.3248 18.778 16.8789 18.8007 16.8758C18.7991 16.8771 18.7848 16.881 18.7615 16.8874C18.5853 16.9353 17.8954 17.1231 18.3199 17.4002H17.6599C17.1173 17.6233 5.89389 17.8993 3.47708 17.8993C3.47708 16.7767 3.31823 12.7513 3.18315 9.32843C3.14829 8.44503 3.11501 7.60177 3.08646 6.85889Z"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.66534 0.348889C1.35675 0.301459 0.84517 0.82319 1.13803 2.10845C1.20433 2.39798 1.06365 8.36909 0.959226 12.8018C0.905999 15.0611 0.862188 16.9207 0.859998 17.4247C0.856291 18.4132 1.68019 18.9926 2.61344 18.5918C2.70413 18.5527 2.79555 18.5093 2.88752 18.4657C3.19311 18.3209 3.50464 18.1732 3.81453 18.1668C4.81271 18.1456 5.81144 18.1474 6.81014 18.1493C8.04243 18.1516 9.27468 18.154 10.5058 18.1129C12.9571 18.0301 15.4075 17.8729 17.8523 17.673C18.8013 17.5958 19.2656 16.7216 19.1785 15.7767C19.0506 14.3901 18.9598 12.9932 18.9755 11.6019C19.0126 8.46409 19.1034 5.32533 19.2183 2.18843C19.2517 1.28168 18.7772 0.907821 18.0209 0.79715C17.1851 0.674962 16.3459 0.575427 15.5066 0.475888C14.8831 0.401935 14.2595 0.327979 13.6373 0.244729C11.8248 0.00195076 7.6787 0.169984 4.99785 0.278634C3.85848 0.324811 2.98376 0.360262 2.66534 0.348889Z"/>
                  </svg>
              </v-btn>
          </div> 
          <p class="notice">*One discount can be applied per order. Only valid when a friend is purchasing from Clean Cut Meals for the first time.</p>
        </div>
      </transition>
      <!-- <transition name="fade">
        <blockAd :view="viewBirthDay"/>
      </transition> -->
      <transition name="fade">
          <div class="block-user-date" v-if="viewBirthDay">
            <h2>Complete your profile</h2>
            <p>Help us make your birthday a special time of year...</p>
            <h3>Enter your birthday</h3>
            <div class="row-data">
                <div class="row-item">
                <h3>Day</h3>            
                  <v-text-field
                      v-model="day"
                      label=""
                      type="number"
                      :max="31"
                      :min="1"
                      :maxlength="2"
                      @keyup="checkValue('day')"
                  >
                  <span class="plus" @click="day < 31 ? day++ : 31"></span>
                  <span class="minus"  @click="day > 1 ? day-- : 1"></span>
                </v-text-field>        
                </div>
                <div class="row-item">
                    <h3>Month</h3>
                    <v-text-field
                      v-model="month"
                      label=""
                      :max="12"
                      :min="1"
                      type="number"
                      :maxlength="2"
                      @keyup="checkValue('month')"
                      >
                      <span class="plus" @click="month < 12 ? month++ : month"></span>
                      <span class="minus"  @click="month > 1 ? month-- : 1"></span>
                  </v-text-field>
                </div>
            </div>
            <div class="row-btn">
                <button class="btn btn-reward" @click.prevent="saveBirthday">Get your reward <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M2.47705 1.72811C4.09305 0.399113 6.13405 -0.0228874 8.50705 0.465113C8.50705 0.465113 9.51605 0.840113 9.94105 1.15111C10.375 1.46811 10.687 1.95211 10.917 2.21011C11.987 1.63111 12.653 0.753113 13.659 0.263113C15.322 -0.546887 18.003 0.641112 19.076 2.08811C20.381 3.84811 20.041 5.64511 19.633 7.49511C19.069 10.0541 17.732 12.2261 16.294 14.3891C14.973 16.3761 13.508 18.1531 11.574 19.5601C10.894 20.0541 10.333 20.1021 9.52805 19.8241C6.91905 18.9221 2.64005 13.4761 2.35505 12.9961C0.824048 10.4261 -0.812952 7.99211 0.451048 4.62511C0.690048 3.98911 1.78105 2.29911 2.47605 1.72811H2.47705ZM12.614 14.8851C15.311 11.8631 17.092 7.61211 17.384 5.96011C17.733 3.98811 16.531 2.37011 14.82 2.93211C13.532 3.35511 12.366 4.07811 12.086 5.58011C11.921 6.46311 11.356 6.84611 10.573 6.92911C9.69405 7.02211 9.32705 6.41711 9.13605 5.66411C9.07205 5.41411 8.98505 5.17011 8.92405 4.91911C8.50205 3.19511 8.16705 2.93911 6.36405 2.97911C4.20705 3.02711 2.63305 4.48211 2.62105 6.59811C2.60905 8.71811 3.79105 10.4121 4.94905 12.0431C5.83705 13.2931 9.09605 16.8281 9.53705 17.5491C9.92705 17.3301 12.349 15.1851 12.616 14.8861L12.614 14.8851Z"/>
                </svg>
                </button>
            </div>
          </div>
      </transition>
    </div>
  </transition>
</template>

<script>

import { url } from '@/api/api.js'
// import blockAd from '@/components/account/blockAd.vue';

export default {
  name: 'mainAccountContent',
  props: ['userDetails'],
  components: {
    // blockAd
  },
  data() {
      return {
          day: '',
          month: '',
          friendsCode: '',
          textBtnCopy: 'Copy',
          viewBirthDay: true
      }
  },
  methods: {
    checkValue(label) {
      if ('day' == label && this.day > 31) {
        this.day = '';
      }

      if ('month' == label && this.month > 12) {
        this.month = '';
      }
    },
    saveBirthday() {
      if (this.day || this.month) {

        let data = {
          user_birthday: {
            day: this.day,
            month: this.month
          }
        }

        this.loader = true;
        this.$store.dispatch('saveUserDetails', data);

        setTimeout(() => {
          this.viewBirthDay = false;
        }, 1000);
      }
    },
    copyToClipboard() {
      const textToCopy = url + '/login/?friend=' + this.friendsCode; 
      const tempInput = document.createElement('input');
      tempInput.value = textToCopy;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);

      this.textBtnCopy = 'Save';

      this.$store.dispatch('setAlertData', { 
        title: 'Save', 
        text: 'Link Copied', 
        type: 'success', 
        visible: true }
      );

      setTimeout(() => {
        this.textBtnCopy = 'Copy';
      }, 2000);
    }
  },
  computed: {
    whatsapp() {
      return 'https://www.addtoany.com/add_to/whatsapp?linkurl=' + url + '%2Flogin%2F?friend=' + this.friendsCode + '/&amp;linkname=Clean%20Cut%20Meals';
    },
    facebook() {  
      return 'https://www.addtoany.com/add_to/facebook?linkurl=' + url + '%2Flogin%2F?friend=' + this.friendsCode + '/&amp;linkname=Clean%20Cut%20Meals';     
    },
    facebookMessendger() {
      return 'https://www.addtoany.com/add_to/facebook_messenger?linkurl=' + url + '%2Flogin%2F?friend=' + this.friendsCode + '&amp;linkname=Clean%20Cut%20Meals';
    },
    twitter() {
      return 'https://www.addtoany.com/add_to/twitter?linkurl=' + url + '%2Flogin%2F?friend=' + this.friendsCode + '/&amp;linkname=Clean%20Cut%20Meals';
    },
    mail() {
      return 'https://www.addtoany.com/add_to/email?linkurl=' + url + '%2Flogin%2F?friend=' + this.friendsCode + '/&amp;linkname=Clean%20Cut%20Meals';
    }
  },
  async beforeMount() {
      this.$store.dispatch('getUserDetails');
  },
  watch: {
    userDetails(newData) {
      if (newData.day) {
        this.day = newData.day;
      }

      if (newData.month) {
        this.month = newData.month;
      }

      if (this.day != '' || this.month != '') {
        this.viewBirthDay = false;
      }

      if (newData.friends_code) {
        this.friendsCode = newData.friends_code;
      }

    }
  }
}
</script >

<style lang="stylus">

.v-field__outline,
.v-btn__overlay,
.v-field__overlay,
.v-btn__underlay {
  display: none!important;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition-duration: .4s;
  text-decoration: none;
  font-weight: 700;

  &.btn-active-plan {
    font-family: 'Manrope', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 2;
    color: #fff;
    height: 30px;
    width: 115px;
    background: #201747;
    border-radius: 80px;
  }

  &.btn-manage-plan {
    background: #fff;
    color: #1D2433;
    text-align: center;
    font-family: Manrope;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    width: 297px;
    height: 50px;
    border-radius: 10px;
  }

  svg {
    margin-left: 15px;
  }

  &.btn-copy {
    width: 124px;
    height: 50px!important;
    background: #685BC7;
    border: 2px solid #685BC7;
    color: #fff;
    text-transform: none;
    leter-spacing: normal;
    border-radius: 10px;
    cursor: pointer;

    svg {
      fill: #fff;
      transition-duration: .3s;
    }

    &:hover {
      color: #685BC7!important; 
      background: transparent;

      svg {
        fill: #685BC7;     
      }
    }
  }

  &:hover {
    background: #2AD2C9;
    color: #1D2433;
  }

  &.btn-reward {
    background: #2AD2C9;
    color: #1D2433;
    border-radius: 10px;
    height: 50px;
    padding: 10px 16px;
    min-width: 100%;

    svg {
      fill: #1D2433;
      transition-duration: .4s;
    }

    &:hover {
      background: #685BC7;
      color: #fff;

      svg {
        fill: #fff;
      }
    }
  }
}

#content #account-test,
#content #account {
  
  .discount-section {
    min-width: calc(50% - 1rem);
    max-width: calc(50% - 1rem);
    margin: 0!important;
    background-color: #685bc7;
    overflou: hidden;
    padding: 2rem 2.5rem 2rem!important;

    &:before {
      display: none;
    }

    .wp-block-uagb-container {
      display: flex;
      flex-direction: column;
    }

    .uagb-container-inner-blocks-wrap  {
      width: 100%;
    }

    .wp-block-image {
      text-align: center;

      img {
        max-width: 50%;
      }
    }

    .uagb-desc-text {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }

    .wp-block-button__link {
      background-color: #F2CD00;
      color: #1d2433;
      padding: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 13px;
      width: auto;
      border-radius: 10px;
      font-size: 18px !important;
      letter-spacing: 0.01em;
      line-height: 24px;
      font-weight: 700;
      text-decoration: none;
      transition-duration: .4s;

      &:hover,
      &:focus,
      &:active {
        background: #2AD2C9;
        color: #1d2433;
        opacity: 1;
      }
    }

    .off {
      gap: 60px;
      margin-bottom: 32px;
      display: flex;
      justify-content: center;
      margin: 0 0 2rem;

      @media (max-width: 767px) {
        gap: 20px;
      }

      p {
        font-size: 22px;
        line-height: calc(32 / 28);
        font-weight: 700;
        text-align: center;
        margin: 0 !important;
        position: relative;
        color: #fff;

        @media (max-width: 767px) {
          font-size: 16px;
        }
        
        &:first-child::after {
          width: 22px;
          right: -48px;
          top: 17px;
          content: "";
          display: block;
          position: absolute;
          width: 25px;
          aspect-ratio: 1;
          background: url(/images/plus-2.svg) no-repeat center / 100% 100%;

          @media (max-width: 767px) {
            font-size: 16px;
          }
        }

        strong {
          font-size: 44px;
          display: block;
          color: #F2CD00;
          line-height: 1.2;
          font-weight: 800;

          @media (max-width: 767px) {
            font-size: 35px;
          }
        }
      }
    }
  }
}

.main-account-content {
  display: flex;
  justify-content: space-between;
  gap: 0 2rem;
  margin-top: 3rem;
  margin-bottom: 3rem;



  @media (max-width: 767px) {
    flex-direction: column;
    gap: 2rem 0;
  }

  &.center {
    justify-content: center;
  }

  & > div {
    width: calc(50% - 1rem);
    border-radius: 20px;
    border: 3px solid #E1E6EF;
    padding: 2.5rem 2.5rem 3.5rem;

    @media (max-width: 767px) {
      width: 100%;
      min-width: 100%;
    }

    &.block-user-date {
      h2 {
        color: #1D2433;
        font-family: Manrope;
        font-size: 32px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
        margin-bottom: .8rem;

        svg {
          margin-left: 15px;
        }
      }     
      
      .row-btn {
        margin-top: .5rem;
      }

      p {
        color: #1D2433;
        font-family: 'Manrope', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      h3 {
        color: #1D2433;
        font-family: Manrope;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 30px;
        margin: 1.5rem 0 0;
      }

      .row-item {
        h3 {
          margin: .5rem 0 .3rem;
          font-size: 16px;
        }
      }

      .row-data {
        display: flex;
        justify-content: space-beetwin;
        align-item: center;
        gap: 0 1rem;

        & > div {
          width: 50%;

          input {
            border-radius: 10px!important;
            border: 2px solid #E1E6EF;
            height: 50px;
            padding: 10px 16px;
            min-height: 30px;
          }
        }
      }
    }
    
    &.block-invite {

      .social {
        display: flex;
        list-style: none;
        padding: none;
        margin: none;
        gap: 0 1rem;
        margin: 1rem 0;

        li {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 50px;
          height: 50px;
          border-radius: 10px;
          padding: 10px 16px;
          transition-duration: .4s;
          cursor: pointer;

          &:hover {
            opacity: .7;
          }

          a {
            display: flex;
            justify-content: center;
            align-items: center;
            transition-duration: .4s;
          }
          &.twitter {
            background: #1DA1F2;

            svg {
              width: 24px;
              height: 28px;
            }
          }

          &.whatsapp {
            background: #25D366;
          }

          &.facebook-messenger,
          &.facebook {
            background: #0084FF;
          }

          &.mail {
            background: #2E2858;
          }
        }
      }

      h3 {
        color: #1D2433;
        font-family: Manrope;
        font-size: 32px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
        margin-bottom: .8rem;

        svg {
          margin-left: 15px;
        }
      }

      .notice {
        color: #1D2433;
        font-family: 'Manrope', sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .text-1 {
        color: #1D2433;
        font-family: 'Manrope', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-bottom: 1.3rem;
      }

      .text-2 {
        color: #1D2433;
        font-family: 'Manrope', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      .text-3 {
        color: #1D2433;
        font-family: 'Manrope', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .invite-form {
        display: flex;
        justify-content: space-beetwin;
        align-item: center;
        gap: .5rem;
        margin: 1rem 0 0;

        .v-input {
          width: 70%;

          input {
            border-radius: 10px!important;
            border: 2px solid #E1E6EF;
            height: 50px;
            padding: 10px 16px;
            min-height: 30px;
          }
        }

        .btn.btn-copy {
          max-width: 30%;
          min-width: 100px;
          box-shadow: none;
        }
      }
    }
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.v-input__control {
    position: relative;

    span {
        position: absolute;
        right: 10px
        width: 24px;
        height: 24px;
        cursor: pointer;
        z-index: 100;
        background-size: cover!important;
        
        &.plus {
            top: 18px;
            transform: rotate(90deg);
            background: url(/src/assets/images/icons/arrow.svg) no-repeat center;
        }

        &.minus {
            bottom: 18px!important;
            transform: rotate(-90deg);
            background: url(/src/assets/images/icons/arrow.svg) no-repeat center;
        }
    }
}

.row-item {
    .v-field__input {
        padding-top: 16px;
        padding-left: 0;
        padding-right: 0;

        input {
            margin: 0;
        }
    }

    .v-label {
        z-index: 100;
    }
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>